import React from 'react';
import WebsitePage from './WebsitePage';

const ContactPage = () => <WebsitePage slug="contact" />;
export default ContactPage;
